var _a;
import { isEqual } from "lodash";
import { useCallback, useEffect } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePrevious } from "../../utils/hooks.utils";
import { generateHooks } from "../generators/generator.hooks";
import { getPaymentRequestsTotalStart } from "./paymentRequest.actions";
import { createCreditNoteStart } from "./paymentRequest.actions";
import { GENERATOR_PARAMS } from "./paymentRequest.constants";
import { paymentRequestsTotal, isFetchingPaymentRequestsTotal, paymentRequestsTotalError, isCreatingCreditNote, createCreditNoteError, } from "./paymentRequest.selectors";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), usePaged = _a.usePaged, useUpdate = _a.useUpdate, useCount = _a.useCount, useInfiniteLoad = _a.useInfiniteLoad, useGetAll = _a.useGetAll;
export var usePaymentRequestsTotal = function (params) {
    var dispatch = useDispatch();
    var _a = params.query, query = _a === void 0 ? {} : _a, shouldRefetch = params.shouldRefetch;
    var prevQuery = usePrevious(query);
    var total = useSelector(function (state) {
        return paymentRequestsTotal(state, query);
    });
    var isFetching = useSelector(function (state) {
        return isFetchingPaymentRequestsTotal(state, query);
    });
    var fetchError = useSelector(function (state) {
        return paymentRequestsTotalError(state, query);
    });
    // Data
    var startFetching = useCallback(function () {
        if (!query) {
            return;
        }
        if (isFetching) {
            return;
        }
        // Always refetch when total is undefined (cache was cleared by hide/unhide)
        if (total === undefined) {
            dispatch(getPaymentRequestsTotalStart.getAction({
                query: query,
            }));
            return;
        }
        if (!shouldRefetch) {
            return;
        }
        // Prevent deep equal check for existing cached data
        if (isEqual(query, prevQuery)) {
            return;
        }
        dispatch(getPaymentRequestsTotalStart.getAction({
            query: query,
        }));
    }, [dispatch, isFetching, query, prevQuery]);
    // Lifecycle
    useEffect(startFetching, [startFetching]);
    return {
        total: total,
        isFetching: isFetching,
        fetchError: fetchError,
    };
};
export var useCreateCreditNote = function () {
    var _a = React.useState(), paymentRequestId = _a[0], setPaymentRequestId = _a[1];
    // Redux
    var dispatch = useDispatch();
    var isCreating = useSelector(function (state) {
        return isCreatingCreditNote(state, paymentRequestId);
    });
    var createError = useSelector(function (state) {
        return createCreditNoteError(state, paymentRequestId);
    });
    // Data
    var createCreditNote = function (_a) {
        var paymentRequestId = _a.paymentRequestId, onSuccess = _a.onSuccess;
        if (!paymentRequestId) {
            return;
        }
        if (isCreating) {
            return;
        }
        setPaymentRequestId(paymentRequestId);
        dispatch(createCreditNoteStart.getAction({ id: paymentRequestId, onSuccess: onSuccess }));
    };
    return {
        createCreditNote: createCreditNote,
        isCreating: isCreating,
        createError: createError,
    };
};
